import { render, staticRenderFns } from "./MobileBottomNav.vue?vue&type=template&id=8c3823f6&scoped=true&"
import script from "./MobileBottomNav.vue?vue&type=script&lang=js&"
export * from "./MobileBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./MobileBottomNav.vue?vue&type=style&index=0&id=8c3823f6&scoped=true&lang=css&"
import style1 from "./MobileBottomNav.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3823f6",
  null
  
)

export default component.exports